import { createAction, createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { signStudentAttendanceSheet } from "./sign-student-attendance-sheet";

const initialState: ProcessingState = { processing: "idle" };

export const resetSignStudentAttendanceSheet = createAction("student/resetSignAttendanceSheet");

export const signStudentAttendanceSheetReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(signStudentAttendanceSheet.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(signStudentAttendanceSheet.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(signStudentAttendanceSheet.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetSignStudentAttendanceSheet, () => {
    return initialState;
  });
});
